import 'source-map-support/register';

require('dotenv').config();
